import React, { Component } from 'react'
import classes from './container.module.css'
import { Link } from 'react-router-dom'

export default class Home extends Component {

    render() {

        return (

            <div className={classes.container}>
                <div className=" mt-24 text-center lg:grid grid-cols-2 pt-40 md:h-screen lg:h-screen xl:h-screen">
                    <section>
                    <h5 className=" text-softGray text-xl tracking-widest lg:text-4xl">SO, YOU WANT TO TRAVEL TO</h5>
                        <h1 className="text-8xl font-Bellefair text-white my-8 lg:text-9xl">SPACE</h1>
                        <p className="text-softGray text-center lg:text-3xl lg:pl-10 lg:pr-28 lg:text-left lg:leading-relaxed">Let’s face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back, and relax because we’ll give you a truly out of this world experience!</p>
                    </section>
                
                    <section>
                        <Link to="/destination">
                            <div className="bg-white rounded-full w-278 h-278 m-auto my-10 flex justify-center items-center lg:w-400 lg:h-400">
                                <h3 className="text-3xl font-Bellefair lg:text-5xl">EXPLORE</h3>
                            </div>
                        </Link>
                    </section>
                   
                </div>
            </div>
        )
    }
}
